import React from 'react';
import { cn } from '../../utils/cn';

const StandardCard = ({ 
  children,
  variant = 'default',
  padding = 'md',
  hover = false,
  className,
  ...props 
}) => {
  const baseStyles = 'bg-white rounded-xl';
  
  const variants = {
    default: 'shadow-md',
    bordered: 'border border-gray-200',
    elevated: 'shadow-lg'
  };
  
  const paddings = {
    none: 'p-0',
    sm: 'p-4',
    md: 'p-6',
    lg: 'p-8'
  };
  
  const hoverStyles = hover ? 'hover:shadow-xl transition-shadow duration-200' : '';
  
  return (
    <div
      className={cn(
        baseStyles,
        variants?.[variant],
        paddings?.[padding],
        hoverStyles,
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
};

export default StandardCard;